export default {
  logIn: 'Log in',
  signUp: 'Sign up',
  logOut: 'Log out',
  signOut: 'Sign out',
  yourAccount: 'Your account',
  accountDashboard: 'Account Dashboard',
  orders: 'Orders',
  billingWallet: 'Billing & Wallet',
  settings: 'Settings',
  favorites: 'Favorites',
  cart: 'Cart',
  searchCatalog: 'Search catalog',
  browseCatalog: 'Browse catalog',
  language: 'Language',
  loading: 'Loading…',
  retry: 'Retry',
  close: 'Close',
  save: 'Save',
  cancel: 'Cancel',
  edit: 'Edit',
};
